$('table.responsive').each(function () {
    var $table = $(this);

    $table.addClass('table').wrap('<div class="table__wrapper"><div class="table__inner"></div></div>');

    var $tableInner = $table.closest('.table__inner'),
        $tableWrapper = $table.closest('.table__wrapper');

    $tableInner.scroll(function () {
        var tableRect = $table[0].getBoundingClientRect(),
            tableInnerRect = $tableInner[0].getBoundingClientRect();

        if (tableRect.right <= tableInnerRect.right + 1) {
            $tableWrapper.removeClass('scrolling');
        }
        else {
            $tableWrapper.addClass('scrolling');
        }
    });

    if ($tableInner.width() == $table.width()) {
        $tableWrapper.removeClass('scrolling');
    }
    else {
        var tableRect = $table[0].getBoundingClientRect(),
            tableInnerRect = $tableInner[0].getBoundingClientRect();

        if (tableRect.right <= tableInnerRect.right + 1) {
            $tableWrapper.removeClass('scrolling');
        }
        else {
            $tableWrapper.addClass('scrolling');
        }
    }

    $(window).resize(function () {
        if ($tableInner.width() == $table.width()) {
            $tableWrapper.removeClass('scrolling');
        }
        else {
            var tableRect = $table[0].getBoundingClientRect(),
                tableInnerRect = $tableInner[0].getBoundingClientRect();

            if (tableRect.right <= tableInnerRect.right + 1) {
                $tableWrapper.removeClass('scrolling');
            }
            else {
                $tableWrapper.addClass('scrolling');
            }
        }
    });
});